import { createSelector } from 'reselect'

import { selectSubjectForSubjectId } from './base'
import { selectSubjectForCategoryType } from '../../customFieldCategories/selectors'

export const selectCustomFieldValueForCustomFieldKeyAndCategoryType = createSelector(
  selectSubjectForCategoryType,
  (state, { customFieldKey }) => customFieldKey,
  (subject, customFieldKey) => {
    if (!subject) return null
    return (
      subject.customFieldValues && subject.customFieldValues[customFieldKey]
    )
  }
)

export const selectCustomFieldValueForCustomFieldKeyAndSubjectId = createSelector(
  selectSubjectForSubjectId,
  (state, { customFieldKey }) => customFieldKey,
  (subject, customFieldKey) => {
    if (!subject) return null
    return (
      subject.customFieldValues && subject.customFieldValues[customFieldKey]
    )
  }
)
